import jsyaml from 'js-yaml';

// CodeMirror yaml plugin expects to find it in window/globals.
window.jsyaml = jsyaml;
